import { Form, Modal, Row, Col, Button, Input, message } from "antd";

import { useTranslation } from "react-i18next";
import { useAppSelector } from "store/hook";

import { CharacterVerify } from "Utility/RegExp";
import { useUpdateUser } from "Components/Management/queries";

interface changePasswordModalProps {
  ChangePassVisible: boolean;
  setChangePassVisible: (arg: boolean) => void;
}
// 顯示修改密碼的彈出視窗
const ChangePasswordModal = ({ ChangePassVisible, setChangePassVisible }: changePasswordModalProps) => {
  // useAppSelector：用於從 Redux 全局狀態中獲取相關數據，如 loginCid、user、level 和 gid。
  const { loginCid, user, level, gid } = useAppSelector((state) => state.global);
  const { t } = useTranslation();
  // 使用 useUpdateUser 鉤子創建異步函數 updateUserMutation，可能用於更新使用者的密碼等信息。
  // 當呼叫 mutateAsync 時，會觸發一個異步操作，會向後端發送請求以更新使用者的密碼，當表單提交時被呼叫。
  const { mutateAsync: updateUserMutation, isLoading: updateUserLoading } = useUpdateUser(loginCid);

  const [form] = Form.useForm();
  // 當修改密碼時的處理函數
  const changeSuperPassword = (values: any) => {
    // 確認新密碼和確認密碼相符
    if (values.password !== values.confirm_password) {
      message.error(t("ISMS.Fail"));
      return;
    }
    // 將修改後的新密碼與相關使用者資訊放入 EditUser 中
    values.EditUser = [
      {
        name: user,
        password: values.password,
        level: level,
        gid: gid,
      },
    ];
    // 呼叫 updateUserMutation 更新使用者信息
    updateUserMutation({ cid: loginCid, values })
      .then(() => {
        message.success(t("ISMS.Success"));
      })
      .catch(() => {
        message.error(t("ISMS.Fail"));
      });
    // 關閉彈出視窗並重置表單
    setChangePassVisible(false);
    form.resetFields();
  };

  return (
    <Modal
      title={t("ISMS.Change Password")}
      visible={ChangePassVisible}
      onCancel={() => {
        setChangePassVisible(false);
        form.resetFields();
      }}
      footer={[
        <Button
          key="submit"
          type="primary"
          loading={updateUserLoading}
          onClick={() => {
            form.submit();
          }}
        >
          {t("ISMS.Submit")}
        </Button>,
      ]}
    >
      <Form onFinish={changeSuperPassword} form={form} layout="vertical">
        <div className="formwrap">
          <Row gutter={24} justify="center">
            <Col xs={24} sm={24} md={24} lg={20} xl={20}>
              {/* 新密碼輸入框 */}
              <Form.Item
                label={t("ISMS.Password")}
                name={"password"}
                // rules 加入 必填設定 與 正則表達
                rules={[{ required: true, message: "Input new password" }, CharacterVerify]}
              >
                <Input.Password placeholder={t("ISMS.InputPassword")} maxLength={30} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24} justify="center">
            <Col xs={24} sm={24} md={24} lg={20} xl={20}>
              {/* 確認密碼輸入框 */}
              <Form.Item
                label={t("ISMS.Confirm Password")}
                name={"confirm_password"}
                // rules 加入 必填設定 與 正則表達
                rules={[{ required: true, message: "Input password again" }, CharacterVerify]}
              >
                <Input.Password placeholder={t("ISMS.Confirm Password")} maxLength={30} />
              </Form.Item>
            </Col>
          </Row>
        </div>
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal;
